import React from "react";

const APP_LOGO_SRC = "/assets/images/logoApp.png";

export default function AppLoader({
  title = "A carregar...",
  message = "A preparar o próximo módulo com segurança.",
  overlay = false,
  compact = false,
  minHeight,
  className = "",
}) {
  const shellClassName = [
    "app-loader-shell",
    overlay ? "app-loader-shell-overlay" : "app-loader-shell-inline",
    compact ? "app-loader-shell-compact" : "",
    className,
  ].filter(Boolean).join(" ");

  return (
    <div
      className={shellClassName}
      style={minHeight ? { minHeight } : undefined}
      role="status"
      aria-live="polite"
    >
      <div className="app-loader-card">
        <div className="app-loader-stage">
          <div className="app-loader-ring" aria-hidden="true">
            <div className="app-loader-ring-track" />
            <div className="app-loader-brand-core">
              <img src={APP_LOGO_SRC} alt="Dissa Ax ERP" className="app-loader-logo" draggable="false" />
            </div>
          </div>
        </div>
        <div className="app-loader-copy">
          <p className="app-loader-title">{title}</p>
          {message ? <p className="app-loader-message">{message}</p> : null}
        </div>
      </div>
    </div>
  );
}